import useCheckAdmin from '@/hooks/use-check-admin';

import HomeContent from '../HomeContent/HomeContent';
import ServersListBar from '../ServersListBar';
import SettingsModal from '../SettingsModal/SettingsModal';
import UploadServerKeys from '../UploadServerKeys/UploadServerKeys';
import WarningPage from '../Warning/WarningPage';
import MobileNavBar from '../mobile-navbar/MobileNavBar';

import classes from './Home.module.css';
import useHome from './useHome';

const Home = () => {
    useCheckAdmin();

    const {
        privateKey,
        chooseServerHandler,
        handleCloseSettingsModal,
        settingsModal,
        serverData,
        emptyData,
        isMobile,
        activeMobileTab,
    } = useHome();

    return (
        <div
            className={classes['home-container']}
            style={{
                gridTemplateColumns:
                    isMobile && activeMobileTab === 0
                        ? '64px 1fr'
                        : isMobile && activeMobileTab !== 0 && '1fr',
            }}>
            {((isMobile && activeMobileTab === 0) || !isMobile) && (
                <ServersListBar
                    style={{
                        height:
                            isMobile && !privateKey
                                ? '100vh'
                                : isMobile && 'calc(100dvh - 64px)',
                    }}
                    onChooseServer={chooseServerHandler}
                />
            )}

            {serverData.length === 0 && emptyData && <WarningPage />}
            {privateKey && privateKey !== undefined ? (
                <>
                    <HomeContent />
                    {settingsModal.visible && (
                        <SettingsModal onClose={handleCloseSettingsModal} />
                    )}
                    {isMobile && <MobileNavBar />}
                </>
            ) : (
                serverData.length !== 0 && <UploadServerKeys />
            )}
        </div>
    );
};
export default Home;
